import { Anchor } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import ParentNamesModal from 'components/MenuManagement/MenuEdit/MenuMapping/Modals/ParentNamesModal';

interface ParentNamesProps {
  itemName: string;
  parentNames: string[];
}

export default function ParentNames({ itemName, parentNames }: ParentNamesProps) {
  const [parentNamesOpened, parentNamesHandlers] = useDisclosure(false);

  return (
    <>
      <Anchor
        component="button"
        variant="sublabel"
        size="sm"
        underline="always"
        onClick={parentNamesHandlers.open}
      >
        {`${parentNames.length} item${parentNames.length === 1 ? '' : 's'}`}
      </Anchor>
      <ParentNamesModal
        itemName={itemName}
        parentNames={parentNames}
        opened={parentNamesOpened}
        close={parentNamesHandlers.close}
      />
    </>
  );
}
